module.exports = __webpack_public_path__ + "img/icon-daishenpin.2a455716.png";